import SystemTaskDetailPage from "./SystemTaskDetailPage";
import SystemTasksPage from "./SystemTasksPage";

export { SystemTaskDetailPage as SystemTaskDetail };
export default SystemTasksPage;
